const departments = {
    leader: 'Responsável',
    leaders: 'Responsáveis do departamento',
    led_departments: 'Departamentos sob sua gestão',
    edit_leaders: 'Gerenciar responsáveis',
    add_leader: 'Adicionar',
    remove_leader: 'Remover',
    no_leaders: 'Sem responsáveis',
    local: 'Gestão local',
    managed_members: 'Membros no âmbito de gestão',
    leader_scope_hint: 'Gerencie as atribuições dos seus departamentos e subdepartamentos.',
    leader_permission_hint: 'Responsáveis gerenciam as atribuições dos seus departamentos e subdepartamentos, sem alterar funções ou hierarquias.',
    primary_synced: 'O departamento principal é gerenciado pelo Feishu.',
    status_active: 'Ativo',
    status_suspended: 'Suspenso',
    status_departed: 'Desligado',
    status_pending: 'Ativação pendente',
    search: 'Pesquisar',
    previous_page: 'Página anterior',
    next_page: 'Próxima página',
    directory_title: 'Membros da organização',
    member_name: 'Membro',
    search_members: 'Pesquisar por nome ou usuário',
    include_descendants: 'Incluir subdepartamentos',
    no_members: 'Nenhum membro encontrado.',
    all_members: 'Todos os membros',
    all_departments: 'Todos os departamentos',
    edit_member: 'Editar departamentos',
    add_child: 'Adicionar subdepartamento',
    expand_department: 'Expandir {{name}}',
    collapse_department: 'Recolher {{name}}',
    title: 'Departamentos',
    description: 'Gerencie os departamentos e os vínculos dos membros desta organização.',
    create: 'Criar departamento',
    edit: 'Editar departamento',
    name: 'Nome do departamento',
    parent: 'Departamento superior',
    root: 'Sem departamento superior',
    id: 'ID do departamento',
    members: 'Departamentos dos membros',
    member_id: 'ID de usuário do membro',
    primary: 'Departamento principal',
    none: 'Não definido',
    assignments: 'Vínculos de departamentos',
    no_assignments: 'Ainda não há vínculos de departamentos.',
    assignment_hint: 'Atribua departamentos locais e, opcionalmente, um principal. Os vínculos do diretório são somente leitura.',
    empty: 'Ainda não há departamentos.',
    readonly: 'Você pode ver os departamentos e seus vínculos. Contate um administrador para fazer alterações.',
    load_error: 'Não foi possível carregar os dados. Tente novamente.',
    mutation_error: 'Não foi possível salvar. Verifique permissões, associação e hierarquia dos departamentos.',
    loading: 'Carregando…',
    synced: 'Gerenciado pelo diretório',
    choose: 'Buscar departamentos',
    organizations_title: 'Organizações e departamentos',
    organizations_description: 'Escolha uma organização para ver ou gerenciar seus departamentos.',
    no_organizations: 'Você não pertence a uma organização. Contate um administrador.',
    organization: 'Organização atual',
    choose_organization: 'Escolha uma organização',
    delete_title: 'Excluir departamento',
    delete_description: 'Excluir “{{name}}”? Mova primeiro os membros e subdepartamentos.',
};
export default Object.freeze(departments);
